export const proficiency: any = {
  id: "",
  proficiency: "",
  description: "",
  organizationId: "",
};
